import { NgModule } from '@angular/core';

import { MrsiRoutingModule } from './mrsi-routing.module';
import { MrsiComponent } from './mrsi.component';
import { SharedModule } from '../shared/shared.module';
import { MaterialModule } from '../core/material.module';
import { OverallFeedbackComponent } from './overall-feedback/overall-feedback.component';
import { EventListComponent } from './event-list/event-list.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';


@NgModule({
  declarations: [MrsiComponent, OverallFeedbackComponent, EventListComponent],
  imports: [
    CommonModule,
    MrsiRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    InfiniteScrollModule,
    MaterialModule,
    SharedModule
  ]
})
export class MrsiModule { }
